import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AllRoleState {
    roleDetails: []
}

const initialState: AllRoleState = {
    roleDetails: []
};

const allRoleSlice = createSlice({
  name: 'allRole',
  initialState,
  reducers: {
    setAllRoleDetails: (state, action: PayloadAction<Partial<AllRoleState>>) => {
      return { ...state, ...action.payload };
    },
    resetAllRole: () => initialState,
  },
});

export const { setAllRoleDetails, resetAllRole } = allRoleSlice.actions;
export default allRoleSlice.reducer;
